import React from 'react'

function PageNotFound() {
  return (
    <div>
      <h1>PAGE NOT  FOUND</h1>
    </div>
  )
}

export default PageNotFound
